export function registerComponents() {
    if (!window.ChelbitVue) return;
    const { defineAsyncComponent } = BX.Vue3;
    window.ChelbitVue.registerComponent('chelbit-auth',
        defineAsyncComponent(() => import('@src/components/Auth/Auth.js'))
    );
    window.ChelbitVue.registerComponent('chelbit-modal',
        defineAsyncComponent(() => import('@src/components/Modal.js'))
    );
    window.ChelbitVue.registerComponent('chelbit-modal-confirm',
        defineAsyncComponent(() => import('@src/components/ModalConfirm.js'))
    );
    window.ChelbitVue.registerComponent('chelbit-brief-options-modal',
        defineAsyncComponent(() => import('@src/components/BriefOptionsModal/BriefOptionsModal.js'))
    );
    window.ChelbitVue.registerComponent('chelbit-user-project-view',
        defineAsyncComponent(() => import('@src/components/UserProject/UserProjectView.js'))
    );
    window.ChelbitVue.registerComponent('chelbit-custom-datepicker',
        defineAsyncComponent(() => import('@src/components/VueDatepicker/CustomDatepicker.js'))
    );
    window.ChelbitVue.registerComponent('chelbit-favorites-modal',
        defineAsyncComponent(() => import('@src/components/FavoritesModal/FavoritesModal.js'))
    );
    window.ChelbitVue.registerComponent('chelbit-manager-project-list',
        defineAsyncComponent(() => import('@src/components/ManagerProject/ManagerProjectList.js'))
    );
    window.ChelbitVue.registerComponent('chelbit-manager-project-detail',
        defineAsyncComponent(() => import('@src/components/ManagerProject/ManagerProjectDetail.js'))
    );
    window.ChelbitVue.registerComponent('chelbit-item-card',
        defineAsyncComponent(() => import('@src/components/Item/ItemCard.js'))
    );
    window.ChelbitVue.registerComponent('chelbit-item-slider',
        defineAsyncComponent(() => import('@src/components/Item/ItemSlider.js'))
    );
    window.ChelbitVue.registerComponent('chelbit-form-new-page',
        defineAsyncComponent(() => import('@src/components/Form/FormNewPage.js'))
    );
    window.ChelbitVue.registerComponent('chelbit-file-input',
        defineAsyncComponent(() => import('@src/components/FileInput.js'))
    );
    window.ChelbitVue.registerComponent('chelbit-number-input',
        defineAsyncComponent(() => import('@src/components/NumberInput.js'))
    );
}
